//获取element的y坐标
export function getElementTop(element) {
    if (!element) {
        console.warn('getElementTop：element不存在');
        return;
    }
    let actualTop = element.offsetTop;
    let current = element.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
}
